module.exports = __webpack_public_path__ + "images/speed-ten-default.ef58f12c4d9b98319f1c9881b3491d3b.png";